export function dup<T>(subject: T): T {
  return JSON.parse(JSON.stringify(subject));
}

